/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var Ladda = require('ladda');

var SubmitComplianceAGReferral = require('../services/SubmitComplianceAGReferral');

var tmplSecComplianceAGReferralEditModalView = require('../templates/SecComplianceAGReferralEditModalView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplSecComplianceAGReferralEditModalView,

  className: 'sec-compliance-ag-referral-edit-modal-view',

  ui: {
    modalBody: '.modal-body',
    AGReferralForm: '.ag-referral-form',
    referralDate: '.referral-date',
    submit: '.submit'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    Syphon.deserialize(this, this.model.toJSON());

    this.ui.referralDate.datepicker();
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;
    this.ui.AGReferralForm.parsley()
      .whenValidate()
      .done(function() {
        var l = Ladda.create(self.ui.submit[0]);
        l.start();

        SubmitComplianceAGReferral(self.getFormData())
          .done(function(updatedAGReferral) {
            self.triggerMethod('modal:close', updatedAGReferral);
          })
          .fail(function() {
            l.stop();
          });
      });
  },

  getFormData: function() {
    var data = Syphon.serialize(this);
    data.complianceId = this.model.get('complianceId');

    return data;
  }
});
